module.exports = __webpack_public_path__ + "499e48c96750585daa3aaa4c4ec8ef9a.jpg";